import { useIsAuthenticated } from '@edge/spark/io-aws'
import { setActiveAuctionId, useActiveAuctionId } from '../activeAuctionIdStore'
import { useAllOrganizations } from './useAllOrganizations'

/** Sets the activeAuctionIdStore value to the first organization if missing and available */
export const useSetFirstAsActiveAuction = () => {
    const loggedIn = useIsAuthenticated()
    const activeId = useActiveAuctionId()
    const allOrgs = useAllOrganizations()

    console.debug(`useSetFirstAsActiveAuction > loggedIn ${loggedIn}`)

    if (!loggedIn) {
        return
    }

    if (allOrgs === null) {
        return // loading
    }

    if (!allOrgs.length) {
        console.error('useSetFirstAsActiveAuction > Missing Organizations')
        return
    }

    if (activeId && allOrgs.find((o) => o.orgId === activeId)) {
        console.debug('useSetFirstAsActiveAuction > Active Organization Found')
        return
    }

    if (allOrgs.length) {
        const firstId = allOrgs[0].orgId

        console.debug(`useSetFirstAsActiveAuction > firstId ${firstId}`)

        if (firstId) {
            setActiveAuctionId(firstId)
        }
    }
}
